// extracted by mini-css-extract-plugin
export default {"cell":"VwwYKzcbqgH3KTvIgggN","placeholder":"lBhzUEim_MwCy1dq1h4d","fade-in":"Cw5hb3SIgM3pclginFD4"};